"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Validation = _interopRequireDefault(require("../Validation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var WithValidation =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(WithValidation, _Component);

  function WithValidation(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      error: false,
      errorMessage: ''
    };
    _this.validation = _this.validation.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));

    _this.validation(_this.props.value);

    return _this;
  }

  var _proto = WithValidation.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return this.props.value !== nextProps.value || this.state.error !== nextState.error;
  };

  _proto.onChange = function onChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    this.props.onChange({
      name: name,
      value: value
    });
    this.validation(value);
  };

  _proto.onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 13) {
      this.validation(e.target.value, true);
    }
  };

  _proto.validation = function validation(value, force) {
    var showMessage = Boolean(this.state.errorMessage || force);
    var validationResult = this.props.validation(value);
    var hasValidationError = validationResult !== true;

    if (this.props.onValidationChange) {
      this.props.onValidationChange(this.props.name, hasValidationError === false);
    }

    if (showMessage) {
      this.setState({
        error: hasValidationError,
        errorMessage: typeof validationResult === 'string' ? validationResult : ''
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        name = _this$props.name,
        value = _this$props.value,
        children = _this$props.children,
        validationProps = _this$props.validationProps;
    var _this$state = this.state,
        error = _this$state.error,
        errorMessage = _this$state.errorMessage;
    return _react.default.createElement("div", null, _react.default.cloneElement(children, {
      name: name,
      onBlur: function onBlur(e) {
        return _this2.validation(e.target.value, true);
      },
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      hasError: error,
      value: value
    }), _react.default.createElement(_Validation.default, _extends({
      visible: error
    }, validationProps), errorMessage));
  };

  return WithValidation;
}(_react.Component);

WithValidation.displayName = 'WithValidation';
WithValidation.propTypes = {
  validationProps: _propTypes.object,
  // eslint-disable-line react/forbid-prop-types
  name: _propTypes.string.isRequired,
  value: _propTypes.string,
  children: _propTypes.node.isRequired,
  validation: _propTypes.func.isRequired,
  onChange: _propTypes.func,
  onValidationChange: _propTypes.func,
  runValidation: _propTypes.bool
};
WithValidation.defaultProps = {
  validationProps: undefined,
  onChange: undefined,
  onValidationChange: undefined,
  runValidation: false,
  value: ''
};
var _default = WithValidation;
exports.default = _default;